var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecorexpublicaplayFinalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1171.86 187.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8a181a;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #2d3893;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.37,76.98h-29.33c-.61-13.44-12.52-22.61-29.94-22.61-15.89,0-27.49,7.94-27.49,19.25,0,15.58,13.75,18.02,31.16,21.38,21.38,3.97,59.27,10.39,59.27,46.44,0,27.19-25.66,45.82-61.71,45.82S.31,168.02,0,140.22h30.55c.61,14.36,14.05,23.83,32.69,23.83,17.41,0,29.94-8.25,29.94-20.77,0-15.58-14.97-18.02-32.08-21.08-22.61-3.36-58.35-10.08-58.35-45.52,0-27.19,23.83-45.21,58.96-45.21s58.66,18.64,58.66,45.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.22,119.14h-128.31c3.97,25.05,23.52,42.46,49.49,42.46,21.38,0,38.43-7.58,44.23-25.6h31c-8.55,33.3-38.58,51.26-75.54,51.26-46.44,0-80.35-32.69-80.35-77.9S186.66,31.46,233.09,31.46s79.73,32.69,80.04,78.21c0,3.05-.31,6.42-.92,9.47ZM184.83,95h98.06c-5.19-22.3-24.75-37.88-49.49-37.88s-43.08,15.58-48.57,37.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.06,187.26c-46.44,0-80.35-32.69-80.35-77.9s33.91-77.9,80.35-77.9c40.94,0,69.99,18.97,74.57,56.54h-29c-7-23-22.36-29.35-45.57-29.35-28.11,0-48.27,21.38-48.27,50.71s20.16,50.71,48.27,50.71c23.52,0,39.57-7.07,45.57-29.07h29c-4.58,37.88-33.64,56.26-74.57,56.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.93,109.36c0,45.21-33.6,77.9-80.04,77.9s-80.35-32.69-80.35-77.9,33.91-77.9,80.35-77.9,80.04,32.69,80.04,77.9ZM556.62,109.36c0,29.63,20.16,50.71,47.96,50.71s48.27-21.08,48.27-50.71-20.16-50.71-48.27-50.71-47.96,21.38-47.96,50.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M718.84,184.51v-92.26c0-36.66,25.05-58.04,68.43-58.04v26.27c-23.22,0-36.97,11.91-36.97,34.52v89.51h-31.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M963.23,119.14h-128.31c3.97,25.05,23.52,42.46,49.49,42.46,21.38,0,40.41-7.58,46.22-25.6h31c-8.55,33.3-40.56,51.26-77.52,51.26-46.44,0-80.35-32.69-80.35-77.9s33.91-77.9,80.35-77.9,79.73,32.69,80.04,78.21c0,3.05-.31,6.42-.92,9.47ZM835.84,95h98.06c-5.19-22.3-24.75-37.88-49.49-37.88s-43.08,15.58-48.57,37.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1105.91,184.51l-45.52-58.66-45.21,58.66h-36.35l59.27-75.46-58.35-74.85h36.05l44.6,57.13,44.6-57.13h36.35l-58.35,74.85,58.96,75.46h-36.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    className: "cls-1",
    d: "M1115.25,21.59l56.61-21.59-8.55,57.63-9.94-34.9-38.12-1.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecorexpublicaplayFinalSvg);
export default __webpack_public_path__ + "static/media/Secorex publica play Final SVG.474d242c2545338ce2434830268c5cd4.svg";
export { ForwardRef as ReactComponent };